import React, { useState, useMemo, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { Box, Button, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import { useStylesLayout } from "../styles/Layout";
import useURL from "../hooks/useURL";
import { actionToLog } from "../store/ducks/duckAudit";

import LoadingComponent from "./LoadingComponent";
import { useAppInsights } from "./AppInsightsProvider";

function IFrameComponent(props) {
  const { sourceUrl, tabId, requiredNormalAuth, sso, requireFormatNumber, sourceId } = props;
  // eslint-disable-next-line
  const { cleanParams } = useURL(requireFormatNumber);
  const { history, historyLoaded } = useSelector((state) => state.layout);
  const sessionLoading = useSelector((state) => state.session.loading);
  const classes = useStylesLayout();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const appInsights = useAppInsights();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const processURL = useCallback(cleanParams, [history, sessionLoading, historyLoaded]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const urlProcesed = useMemo(
    () => processURL(sourceUrl, requiredNormalAuth, sso),
    [processURL, sourceUrl, requiredNormalAuth, sso],
  );

  useEffect(() => {
    dispatch(
      actionToLog({
        action: "DEFAULT",
        pathMenu: location.pathname,
        resource: "Source",
        resourceId: sourceId,
        details: sourceUrl,
        category: "SOURCE",
      }),
    );
  }, [dispatch, sourceId, sourceUrl]);

  const handleLoad = () => {
    setLoading(false);
    setHasError(false);
  };

  const handleError = () => {
    setLoading(false);
    setHasError(true);
    appInsights.setAuthenticatedUserContext(localStorage.getItem("Email"));
    appInsights.trackEvent({
      name: "Error al cargar el Iframe",
      properties: { filters: history, sourceUrl },
    });
  };

  useEffect(() => {
    setLoading(true);
    setHasError(false);
  }, [history, urlProcesed]);

  const handleOpenInNewTab = () => {
    if (urlProcesed) {
      window.open(urlProcesed, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <>
      {loading || sessionLoading ? (
        <LoadingComponent withoutNavBar loading={loading || sessionLoading} />
      ) : null}

      {hasError ? (
        <Box
          className={classes.pageContent}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: 1,
            p: 2,
          }}
        >
          <Typography align="center" variant="body1">
            No se pudo cargar este reporte embebido.
          </Typography>
          <Typography align="center" color="text.secondary" variant="body2">
            Puedes abrirlo en una nueva pestaña.
          </Typography>
          <Button variant="contained" onClick={handleOpenInNewTab}>
            Abrir en nueva pestaña
          </Button>
        </Box>
      ) : (
        <iframe
          className={classes.pageContent}
          id={`Iframe-Tan-${tabId}`}
          loading="auto"
          src={urlProcesed}
          style={{
            border: 0,
            display: loading || sessionLoading ? "none" : "block",
            height: "100%",
            position: "absolute",
            width: "100%",
          }}
          title={`iframe-tab-${tabId}`}
          onError={handleError}
          onLoad={handleLoad}
        />
      )}
    </>
  );
}

IFrameComponent.propTypes = {
  sourceUrl: PropTypes.string.isRequired,
  tabId: PropTypes.number.isRequired,
  requiredNormalAuth: PropTypes.bool.isRequired,
};

export default React.memo(IFrameComponent);
